import { UserRole } from '@app/types'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { Separator } from '@/components/ui/separator'
import { DOCUMENT_ROLE_LABELS_MAP } from '../../../documents.constants'
import type { DocumentRoleOption } from '../../../hooks/useDocumentRoleOptions'

const ADMIN_LABEL = DOCUMENT_ROLE_LABELS_MAP[UserRole.ADMIN]

const CHECKBOX_CLASS =
  'border border-border bg-background text-primary data-[state=checked]:border-primary data-[state=checked]:bg-primary/10 data-[state=checked]:text-primary'

type PermissionsRoleListProps = {
  roleOptions: DocumentRoleOption[]
  roleIds: string[]
  isPrivate: boolean
  onToggleRole: (roleId: string, checked: boolean) => void
  onSetPrivate: (checked: boolean) => void
  rolesError?: string
}

export const PermissionsRoleList = ({
  roleOptions,
  roleIds,
  isPrivate,
  onToggleRole,
  onSetPrivate,
  rolesError,
}: PermissionsRoleListProps) => {
  return (
    <>
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2 rounded-md border p-3 bg-slate-50">
          <Checkbox checked disabled id="admin-role" className={CHECKBOX_CLASS} />
          <Label htmlFor="admin-role" className="font-normal">
            {ADMIN_LABEL} <span className="text-muted-foreground">— always have access</span>
          </Label>
        </div>

        <div className="flex items-center gap-2 rounded-md border p-3">
          <Checkbox
            id="private-visibility"
            checked={isPrivate}
            onCheckedChange={(checked) => onSetPrivate(checked === true)}
            className={CHECKBOX_CLASS}
          />
          <Label htmlFor="private-visibility" className="font-normal">
            Private — only you and Admins can view, download and edit this document.
          </Label>
        </div>
      </div>

      <Separator />

      <div className="flex flex-col gap-2">
        {roleOptions.map((role) => (
          <div key={role.id} className="flex items-center gap-2 rounded-md border p-3">
            <Checkbox
              id={`role-${role.id}`}
              checked={!isPrivate && roleIds.includes(role.id)}
              onCheckedChange={(checked) => onToggleRole(role.id, checked === true)}
              className={CHECKBOX_CLASS}
            />
            <Label htmlFor={`role-${role.id}`} className="font-normal">
              {role.label}
            </Label>
          </div>
        ))}
      </div>

      {rolesError && <p className="text-sm text-destructive">{rolesError}</p>}
    </>
  )
}
